import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import axios from 'axios'
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from "styled-components";
import { theme } from './theme';
import { ModalSwitch } from './components/ModalRouter';
import { AppBar } from './components/AppBar';
import { Footer } from './components/Footer';
import { AuthContext, UserInterface, Wallet } from './context/auth';
import { Dialog } from '@material-ui/core';
import {
    StyledDialogContent,
    DialogTitle,
    DialogDescription,
    SaveButton,
    CloseButton,
    FlexWrapper
} from './components/dialogs/Dialogs.styles';

function App() {
  const [user, setUser] = useState<UserInterface | null>(null);
  const [wallet, setWallet] = useState<Wallet | null>(null);
  const existingTokens = localStorage.getItem('token');
  const [authToken, setAuthToken] = useState(existingTokens);
  const [isLoading, setLoading] = useState(!!existingTokens);
  const mobileSize = useRef<HTMLDivElement>(null);
  const setToken = (data: string) => {
    localStorage.setItem('token', data);
    setAuthToken(data);
  }

  const logout = () => {
    localStorage.removeItem('token');
    setAuthToken(null);
    setUser(null);
    setWallet(null);
    axios.get('/api/v2/rest-auth/logout/');
  }

  const fetchUserWallet = () => {
    axios.get(`/wallet/api/payments/wallets/user-wallet/`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
      const {
        available_points,
        has_wallet,
        purchased_dovepoints
      } = res.data;
      setWallet({
        availablePoints: available_points,
        hasWallet: has_wallet,
        purchasedDovepoints: purchased_dovepoints
      })
    })
  }
  const refreshDovePoints = () => {
    fetchUserWallet();
  }
  useEffect(() => {
    if (authToken) {
      axios.get("/api/v2/rest-auth/user/", { headers: { DTOKEN: `${authToken}` } }).then(res => {
        const userData = res.data;
        setToken(res.data.token);
        setUser({
          ...user,
          displayName: userData.display_name,
          isAdmin: userData.is_admin,
          verifiedAccount: userData.verified_account,
          gender: userData.gender,
          image: userData.image
        })
        fetchUserWallet();
        setLoading(false);
      })
    } else {
      axios.get("/api/v2/rest-auth/user/").then(res => {
        const userData = res.data;
        setUser({
          ...user,
          displayName: userData.display_name,
          isAdmin: userData.is_admin,
          verifiedAccount: userData.verified_account,
          gender: userData.gender,
          image: userData.image
        })
        setToken(res.data.token);
        fetchUserWallet();
        setLoading(false);
      })
    }
  }, [authToken]);
  if (mobileSize.current) {
    sessionStorage.setItem('width', `${mobileSize.current.clientWidth - 32}`);
  }
  const userConfirmation = useCallback((message, callback) => {
    const node = document.getElementById('modal-wrapper');
    if (node) {
      ReactDOM.render(
        <ThemeProvider theme={theme}>
          <Dialog
            open
            fullWidth
          >
            <StyledDialogContent>
              <DialogTitle>Warning</DialogTitle>
              <DialogDescription>Are you sure you want to discard changes? This action is invertible and all data will be lost.</DialogDescription>
              <FlexWrapper>
                <CloseButton type="button" onClick={() => {
                  callback(false);
                  ReactDOM.unmountComponentAtNode(node);
                }}>Cancel</CloseButton>
                <SaveButton type="button" onClick={() => {
                  callback(true)
                  sessionStorage.removeItem('oldTitle');
                  sessionStorage.removeItem('uniqueTitle');
                  sessionStorage.removeItem('disabledTypeChange');
                  sessionStorage.removeItem('publicUrl');
                  ReactDOM.unmountComponentAtNode(node);
                }}>Discard changes</SaveButton>
            </FlexWrapper>    
          </StyledDialogContent>
        </Dialog>
      </ThemeProvider>, node)
    }
  }, []);

  return (
    <AuthContext.Provider value={{ refreshDovePoints, authToken, setToken, logout, user, isLoading, setUser, wallet, setWallet }}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
          <Router getUserConfirmation={userConfirmation}>
              <AppBar />
              <div id="modal-wrapper" ref={mobileSize}></div>
              <ModalSwitch />
              <Footer />
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </AuthContext.Provider>
  );
}

export default App;
